import { Container, Row, Col } from 'react-bootstrap';
import { Shield, CircleCheckBig } from 'lucide-react';

const ProtectionSection = () => {
  const protections = [
    "Verified user and borrower community",
    "Comprehensive owner & renter background checks",
    "Every payment is secured and protected by the platform",
    "24/7 customer support for assistance from our team",
    "Advanced fraud prevention and secure user matching"
  ];

  return (
    <section className="section-padding" style={{backgroundColor: 'white'}}>
      <Container>
        <Row className="align-items-start ">
          {/* Left Content */}
          <Col lg={6}>
            <h2 className="display-5 fw-bold mb-4" style={{color: 'var(--text-dark)', letterSpacing: "-2.4px"}}>
              Your Items Are Protected
            </h2>
            <p className="mb-4 text-gray fs-5 " style={{lineHeight:'28px'}} >
              We've built comprehensive safety measures to protect both owners 
              and renters, giving you peace of mind with every transaction.
            </p>

            <div className="mb-2 ">
              {protections.map((protection, index) => (
                <div key={index} className="d-flex align-items-center">
                  <div 
                    className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 me-3 mt-1"
                    style={{
                      width: '24px',
                      height: '24px',
                    }}
                  >
                    <CircleCheckBig size={20} className='text-green'/>
                  </div>
                  <span style={{color: '#000', lineHeight:'28px'}}>{protection}</span>
                </div>
              ))}
            </div>
          </Col>

          {/* Right Content - Shield Icon */}
          <Col lg={6} className="text-center mt-5 animate-bounce ">
            <div 
              className="sheild-icon rounded-4 d-inline-flex align-items-center justify-content-center bg-light-green"
              style={{
                width: '320px',
                height: '320px'
              }}
            >
              <Shield size={128}  className='text-dark-green'/>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ProtectionSection;